<template>
  <div class="d-flex flex-column">
    <div class="mx-auto">
      <form class="form" autocomplete="off" @submit.prevent="onSearch">
        <label for="text">
          <h1 class="h3 mb-4 text-primary">Search for Internet Resource Registration Data</h1>
          <small class="text-secondary">
            E.g.
            <router-link tag="span" to="/autnum/AS4608">AS4608</router-link>,
            <router-link tag="span" to="/entity/NO4-AP">NO4-AP</router-link>,
            <router-link tag="span" to="/ip/2001:dc0::/32">2001:dc0::/32</router-link>,
            <router-link tag="span" to="/ip/202.12.31.0/24">202.12.31.0/24</router-link>
          </small>
        </label>
        <div class="d-flex">
          <div class="w-100 search-box">
            <input
              class="form-control"
              placeholder="Search..."
              aria-label="Search"
              v-model.trim="searchQuery"
            >
            <button
              class="search-clear"
              type="button"
              v-show="searchQuery"
              @click.prevent="clearQuery()"
            >
              <i class="fa fa-times-circle"></i>
            </button>
          </div>
          <div class="flex-shrink-1">
            <input
              id="js-search"
              type="submit"
              class="btn btn-primary ml-2"
              @click.prevent="onSearch()"
              value="Search"
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
	data() {
		return {
			searchQuery: ""
		};
	},
	props: {
		searchType: { type: String, default: "all" }
	},
	created() {
		const params = this.$route.params;
		this.watchRouteChange(params);
	},
	watch: {
		"$route.params"(params) {
			this.watchRouteChange(params);
		}
	},
	methods: {
		watchRouteChange(params) {
			const address = params.address;
			const bits = params.bits;
			let searchQuery = "";

			if (address) {
				searchQuery = address;
				if (bits) {
					searchQuery += "/" + bits;
				}
				this.searchQuery = searchQuery;
			} else {
				this.clearQuery();
			}
		},
		clearQuery() {
			this.searchQuery = "";
		},
		onSearch() {
			const value = this.searchQuery;
			let searchType = this.searchType;
			if (value.length > 0) {
				if (searchType === "all") {
					if (this.isIPQuery(value)) {
						searchType = "ip";
					} else if (this.isEntityQuery(value)) {
						searchType = "entity";
					} else if (this.isAutnum(value)) {
						searchType = "autnum";
					} else {
						return this.$store.dispatch("searchStore/handleInvalidSearch");
					}
				}
				this.$router.push(`/${searchType}/${value}`);
			}
		},
		isIPQuery(value) {
			// check multiple / slashes
			if (value.split("/").length > 2) {
				return false;
			}
			// Setup a regular expression to test for lowercase or uppercase characters.
			if (value.indexOf(".") !== -1 || value.indexOf(":") !== -1) {
				return true;
			}
			return false;
		},
		isEntityQuery(value) {
			// Setup a regular expression to test if value contains only letters , numbers , hyphen and underscore
			const entityPatern = new RegExp("^[0-9A-Za-z_-]+$");
			// If the value contains only letters , numbers , hyphen and underscore
			if (value.match(entityPatern) && value.indexOf("-") !== -1) {
				return true;
			}
			return false;
		},
		isAutnum(value) {
			const autnumRegex = new RegExp("^(as|AS|aS|As)[0-9]+$");
			if (Number(value) > 0 || value.match(autnumRegex)) {
				return true;
			}
			return false;
		}
	}
};
</script>

<style scoped lang="scss">
small span:hover {
	cursor: pointer;
	text-decoration: underline;
}
.search-box {
	position: relative;
	.search-clear {
		color: #999;
		background: transparent;
		border-color: transparent;
		position: absolute;
		top: 6px;
		right: 2px;
	}
}
</style>
